export const parsePresetPersonaIds = (searchParams: URLSearchParams): string[] => {
  const raw = searchParams.get('personaIds');
  if (!raw) return [];
  const seen = new Set<string>();
  const result: string[] = [];
  for (const part of raw.split(',')) {
    const id = part.trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    result.push(id);
  }
  return result;
};
